import { createSlice } from "@reduxjs/toolkit"

type Filter = {
    [key: string]: string | string[]
}

const initialState: Filter = {
    commodities: 'All',
    districts: 'All'
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        updateCommodities(state: Filter, action) {
            return {
                ...initialState,
                commodities: action.payload
            }
        },
        updateDistricts(state: Filter, action) {
            return {
                ...initialState,
                districts: action.payload
            }
        },
    }
})

export const { updateCommodities, updateDistricts } = filterSlice.actions
export default filterSlice.reducer;
